import React from 'react';
import {useState, useEffect} from "react";
import {useParams, useNavigate, Navigate} from 'react-router-dom';
import {deleteEvent} from "./apiService";

const DeleteEvent = (props) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();

  const { eventIdParam } = useParams();
  console.log('eventIdParam', eventIdParam);

  useEffect(() => {
	let eventIdProp = eventIdParam;
	if(eventIdProp == null) {
		return;
	}
	deleteEvent(eventIdProp).then(
	  data => {
		console.log('DeleteEvent.useEffect deleteEvent data', data);
		if(data.status === 401) {
		  navigate('/login', {replace: true});
		}
		if(data.status !== 200) {
		  setIsLoaded(true);
		  setError(data);
		  return;
		}
		setIsLoaded(true);
	  },
	  error => {
		setIsLoaded(true);
		setError(error);
		console.error('error object', error);
	  }
	);
  }, [eventIdParam, navigate]);

  if(error) {
	return <div>Error: {error.message}</div>;
  }
  if(!isLoaded) {
	return <div>Loading...</div>;
  }
  // navigate("/", { replace: true });
  return <div><Navigate to="/events" replace={true} /></div>;
};

export default DeleteEvent;